// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8447) return "static/chunks/8447-0ad7252261007b09.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "525d753a91767426" + ".js";
};